import React from "react";
import { Modal, ModalBody, ModalFooter } from "reactstrap";
import ModalHeader from "@dhn/components/molecules/modal-header";
import StatusBadge from "@dhn/components/molecules/status-badge";
import ActionButton from "@dhn/components/molecules/action-button";
import { SectionSubtitle } from "@dhn/components/molecules/section-header";
import DetailList from "@dhn/components/molecules/detail-list";
import useAccessUserProfileDetails from "./useAccessUserProfileDetails";

// Información del usuario de farmacia, call center o administración;
// equivalente a la ficha del médico en el consultorio.
export default function AccessUserProfileModal({
  isOpen,
  onClose,
  user,
  profile,
  providerLabel = "Farmacia",
  providerName,
}) {
  const details = useAccessUserProfileDetails({
    isOpen,
    user,
    profile,
    providerLabel,
    providerName,
  });

  return (
    <Modal isOpen={isOpen} toggle={onClose} size="lg" centered>
      <ModalHeader
        toggle={onClose}
        iconClass="fa-user"
        description={details.fullName}
        subtitle="Revise los datos del usuario y su acceso."
      />
      <ModalBody>
        <SectionSubtitle>{`${providerLabel} y sucursal`}</SectionSubtitle>
        <DetailList items={details.accessFields} />

        <SectionSubtitle>Datos del usuario</SectionSubtitle>
        <DetailList
          items={[
            ...details.userFields,
            { label: "Estado", value: <StatusBadge color="success">Activo</StatusBadge> },
          ]}
        />
      </ModalBody>
      <ModalFooter>
        <ActionButton action="close" onClick={onClose} />
      </ModalFooter>
    </Modal>
  );
}
